import styled from "styled-components";

import { windowWidth } from "@styles/global";

interface IdentifierProps {
  active: boolean;
}

const Identifier = styled.div<IdentifierProps>`
  height: 100%;
  width: 5px;
  transition: all 0.3s ease-in-out;
  background-color: ${({ active, theme }) => (active ? theme.colors.primary : theme.colors.disabled)};
  border-radius: 10px;

  @media (max-width: ${windowWidth.mobile.large}) {
    transition: all 0.5s ease-in-out;
    display: ${(props) => (props.active ? "none" : "block")};
    height: 25%;
    width: 10px;
    transform: translateX(5px);
  } ;
`;

const IdentifierMobile = styled.div<IdentifierProps>`
  transition: all 0.3s ease-in-out;
  background-color: ${({ active, theme }) => (active ? theme.colors.primary : theme.colors.disabled)};
  border-radius: 10px;
  display: none;
  position: absolute;
  @media (max-width: ${windowWidth.mobile.large}) {
    display: block;
    height: 25%;
    width: 10px;
    transform: translateX(-5px);
  } ;
`;

const DrawerContent = styled.div`
  overflow: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: ${windowWidth.mobile.large}) {
    width: 100vw;
  } ;
`;

export { Identifier, DrawerContent, IdentifierMobile };
